import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  SET_CATEGORIES,
} from '../actions/auth/auth.actiontype';

const initialState = {
  user: {},
  accessToken: null,
  categories: [],
  isProcessing: false,
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        isProcessing: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        isProcessing: false,
        error: null,
      };

    case LOGIN_ERROR:
      return {
        ...state,
        isProcessing: false,
        error: action.payload,
        user: {},
        accessToken: null,
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        user: {},
        accessToken: null,
        categories: [],
        error: null,
      };

    case SET_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };

    default:
      return state;
  }
}
